import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';

//MUI components
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';

// REDUX
import {connect} from 'react-redux';
import {searchPerformedOnSelector} from 'redux/slices/searchFormSlice';

const MoreDataError = ({searchPerformedOn}) => {
  const errorRef = useRef(null);

  useEffect(() => {
    errorRef.current.scrollIntoView();
  }, [errorRef]);

  return (
    <Grid container justifyContent="center" alignItems="center" direction="column" style={{padding: '0 0 24px 0'}}>
      <Alert ref={errorRef} severity="error">
        There are problems with fetching more {searchPerformedOn}s. Please try again.
      </Alert>
    </Grid>
  );
};

MoreDataError.propTypes = {
  searchPerformedOn: PropTypes.string
};

const mapStateToProps = (state) => ({
  searchPerformedOn: searchPerformedOnSelector(state)
});

export default connect(mapStateToProps)(MoreDataError);
